import { connect } from 'react-redux';
import View from './YearHomePurchaseView';
import { isPopulatedSelector } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { updateData, updateSupportData } from '../../../AdvWorkflow/AdvWorkflowActions';
import {
  nullableDesiredPurchaseYearSelector,
  nullablePurchaseAtRetirementSelector,
  yearOptionsOrDefaultSelector,
  selectedYearOptionOrDefaultSelector,
  selectedYearOptionIsValidSelector,
} from './YearHomePurchaseSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';
import isHomePurchaseGoalValidSelector from '../../HomePurchaseWorkflowSelector';
import { isNumeric } from '../../../../../js/app/react/validators';

const mapStateToProps = (state, ownProps) => ({
  yearOptionsOrDefault: yearOptionsOrDefaultSelector(state, ownProps),
  selectedYearOptionOrDefault: selectedYearOptionOrDefaultSelector(state, ownProps),

  isPopulated: isPopulatedSelector(state, ownProps),
  doNotSave: !isHomePurchaseGoalValidSelector(state, ownProps),

  nullableDesiredPurchaseYear: nullableDesiredPurchaseYearSelector(state, ownProps),
  nullablePurchaseAtRetirement: nullablePurchaseAtRetirementSelector(state, ownProps),
  workflowId: ownProps.workflowId,

  selectedYearOptionIsValid: selectedYearOptionIsValidSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  stepValidator: selectedYearOptionIsValid => () => {
    if (!selectedYearOptionIsValid) {
      return ['Please specify a valid purchase year.'];
    }
    return [];
  },

  preprocessYearHomePurchase: (
    workflowId,
    nullableDesiredPurchaseYear,
    nullablePurchaseAtRetirement,
  ) => {
    let YearHomePurchase = '';

    if (nullablePurchaseAtRetirement === true) {
      YearHomePurchase = 'At Retirement';
    }

    if (nullablePurchaseAtRetirement === false && nullableDesiredPurchaseYear !== null) {
      YearHomePurchase = `${nullableDesiredPurchaseYear}`;
    }
    dispatch(updateSupportData(
      {
        [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
          YearHomePurchase,
        },
      },
      workflowId,
    ));
  },
  onYearHomePurchaseChanged: workflowId => ({ target: { value } }) => {
    dispatch(updateSupportData(
      {
        [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
          YearHomePurchase: `${value}`,
        },
      },
      workflowId,
    ));

    let PurchaseAtRetirement = null;
    let DesiredPurchaseYear = null;

    if (value === 'At Retirement') {
      PurchaseAtRetirement = true;
    } else if (isNumeric(value)) {
      PurchaseAtRetirement = false;
      DesiredPurchaseYear = +value;
    }

    dispatch(updateData(
      {
        [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
          PurchaseAtRetirement,
          DesiredPurchaseYear,
        },
      },
      workflowId,
    ));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
